import React, { useState } from 'react';
import { useDrop } from 'react-dnd';
import { getDatabase, ref, update } from 'firebase/database';
import ImageWidget from './WidgetTypes/ImageWidget';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import './PagePreview.css';
import HeroHeader from './WidgetTypes/HeroHeader';
import HiWidget from './WidgetTypes/HiWidget';
import VideoTeaser from './WidgetTypes/VideoTeaser';
import SimplisticHeader from './WidgetTypes/SimplisticHeader';
import SupremeTestimonial from './WidgetTypes/SupremeTestimonial';
import SimplisticQuote from './WidgetTypes/SimplisticQuote';
import MethodologyWidget from './WidgetTypes/MethodologyWidget';
import PersonalBrandingWidget from './WidgetTypes/PersonalBrandingWidget';
import SimplisticTestimonial from './WidgetTypes/SimplisticTestimonial';
import SimplisticServices from './WidgetTypes/SimplisticServices';
import BulletPointsWidget from './WidgetTypes/BulletPointsWidget';
import ComparisonWidget from './WidgetTypes/ComparisonWidget';
import ProductInfoWidget from './WidgetTypes/ProductInfoWidget';
import ProductFormPopup from './WidgetTypes/ProductFormPopup';
import EventInfoWidget from './WidgetTypes/EventInfoWidget';
import CourseInfoWidget from './WidgetTypes/CourseInfoWidget';
import InfiniteBanner from './WidgetTypes/InfiniteBanner';
import QAWidget from './WidgetTypes/QAWidget';
import HolisticTestimonial from './WidgetTypes/HolisticTestimonial';
import BragBar from './WidgetTypes/BragBar';
import SpiritualFeatureBanner from './WidgetTypes/SpiritualFeatureBanner';
import FancyFooter from './WidgetTypes/FancyFooter';
import AchievementsBanner from './WidgetTypes/AchievementsBanner';
import SpiritualQuoteCard from './WidgetTypes/SpiritualQuoteCard';
import GalleryWidget from './WidgetTypes/GalleryWidget';
import AIPageCreator from './AIPageCreator';
import NewNavCreator from './WidgetEditComponents/NewNavCreator';

function PagePreview({ pageData, onRemoveWidget, onAddWidget, onReorderWidgets, onToggleActivation, onUpdateWidget, onDuplicateWidget, selectedWidget, pageId, spaceId, userId, isMobileView, colors = {}, colorAssignments = {}, spaceFonts = {}, isNavigationEnabled = false, onToggleNavigation, isWidgetEditCollapsed = false, isAddWidgetsCollapsed = false }) {
  const [showAIPageCreator, setShowAIPageCreator] = useState(false);
  
  // Extract spaceName from pageData or derive from spaceId
  const spaceName = pageData?.spaceName || spaceId;
  const handleRemoveClick = (event, widgetId) => {
    event.stopPropagation();
    onRemoveWidget(widgetId);
  };

  const [, drop] = useDrop(() => ({
    accept: 'widget',
    drop: (item, monitor) => {
      if (item && item.widgetType) {
        onAddWidget(item.widgetType);
      }
    }
  }));

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    onReorderWidgets(result.source.index, result.destination.index);
  };

  const handleWidgetClick = (widgetId) => {
    // Prüfen, ob das angeklickte Widget bereits das aktuell ausgewählte ist
    if (selectedWidget && widgetId === selectedWidget.id) {
      // Wenn ja, führen Sie keine Aktion aus (verhindern Sie das erneute Laden/Flackern)
      return;
    }
    // Andernfalls, rufen Sie die Funktion onToggleActivation auf, um das Widget zu aktivieren/deaktivieren
    onToggleActivation(widgetId);
  };

  const renderWidget = (widget) => {
    const isSelected = widget.id === selectedWidget?.id;
    const clickHandler = () => handleWidgetClick(widget.id);
    const removeHandler = (event) => handleRemoveClick(event, widget.id);
    const duplicateHandler = () => onDuplicateWidget && onDuplicateWidget(widget.id);

    switch (widget.type) {
         case 'HeroHeader':
          return <HeroHeader data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} onDuplicate={duplicateHandler} isEditMode={true} colors={colors} colorAssignments={colorAssignments} spaceFonts={spaceFonts} />;
         case 'HiWidget':
          return <HiWidget data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
         case 'VideoTeaser':
          return <VideoTeaser data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
         case 'SimplisticHeader':
          return <SimplisticHeader data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
         case 'SupremeTestimonial':
          return <SupremeTestimonial data={widget} isSelected={isSelected} onRemove={removeHandler} isEditMode={true} />;
         case 'SimplisticQuote':
          return <SimplisticQuote data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
         case 'MethodologyWidget':
          return <MethodologyWidget data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
         case 'PersonalBrandingWidget':
          return <PersonalBrandingWidget data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
         case 'SimplisticTestimonial':
          return <SimplisticTestimonial data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
         case 'SimplisticServices':
          return <SimplisticServices data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
         case 'BulletPointsWidget':
          return <BulletPointsWidget data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
         case 'ComparisonWidget':
          return <ComparisonWidget data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'ProductInfoWidget':
          return <ProductInfoWidget key={`${widget.id}-${widget.productId}`} data={widget} isSelected={isSelected} onRemove={removeHandler} isEditMode={true} />;
        case 'EventInfoWidget':
          return <EventInfoWidget key={`${widget.id}-${widget.eventId}`} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'CourseInfoWidget':
          return <CourseInfoWidget key={`${widget.id}-${widget.courseId}`} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'InfiniteBanner':
          return <InfiniteBanner key={widget.id} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'QAWidget':
          return <QAWidget key={widget.id} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'HolisticTestimonial':
          return <HolisticTestimonial key={widget.id} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'BragBar':
          return <BragBar key={widget.id} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'SpiritualFeatureBanner':
          return <SpiritualFeatureBanner key={widget.id} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'FancyFooter':
          return <FancyFooter key={widget.id} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} pageData={pageData} />;
        case 'AchievementsBanner':
          return <AchievementsBanner key={widget.id} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'SpiritualQuoteCard':
          return <SpiritualQuoteCard key={widget.id} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
        case 'GalleryWidget':
          return <GalleryWidget key={widget.id} data={widget} isSelected={isSelected} onRemove={removeHandler} onUpdate={onUpdateWidget} onSelectWidget={onToggleActivation} isEditMode={true} />;
     
         default:
        return <div>Unknown Widget</div>;
    }
  };

  // Hintergrundfarbe festlegen
  const backgroundColor = pageData.backgroundColor || '#FFFFFF';
  
  // ✅ Navigation Update Handler - FIXED
  const handleNavigationUpdate = (updates) => {
    // ✅ Build path from available data
    if (!userId && !spaceId && !pageId) {
      console.error('❌ No page identifiers available');
      return;
    }
    
    const db = getDatabase();
    
    // Build correct Firebase path
    let firebasePath;
    if (spaceId && userId) {
      // 3-Level: userId/spaceId/pageName
      const pageName = pageId || 'home';
      firebasePath = `/pages/${userId}/${spaceId}/${pageName}/navigation`;
    } else if (userId && pageId) {
      // 2-Level: userId/pageName
      firebasePath = `/pages/${userId}/${pageId}/navigation`;
    } else if (pageId) {
      // Legacy: pageId only
      firebasePath = `/pages/${pageId}/navigation`;
    } else {
      console.error('❌ Cannot build Firebase path');
      return;
    }
    
    console.log('💾 Saving navigation to:', firebasePath, updates);
    
    const navigationRef = ref(db, firebasePath);
    update(navigationRef, updates)
      .then(() => console.log('✅ Navigation saved'))
      .catch((error) => console.error('❌ Save error:', error));
  };

  return (
    <div 
      ref={drop} 
      className={`page_preview ${isMobileView ? 'mobile-preview-mode' : 'desktop-preview-mode'}`} 
      style={{ backgroundColor }}
    >
      <div className="page_preview_header">
        <div>
          <p>Page Start</p>
          <img src="/img/down_2.svg" alt="" />
        </div>
        
        {/* ✅ Navigation Toggle Button - Rechts neben Page Start */}
        {onToggleNavigation && (
          <button
            className={`page-start-nav-toggle ${isNavigationEnabled ? 'active' : ''}`}
            onClick={() => onToggleNavigation(!isNavigationEnabled)}
            title={isNavigationEnabled ? "Disable Navigation" : "Enable Navigation"}
          >
            <i className="fas fa-bars"></i>
            <span>{isNavigationEnabled ? 'Navigation ON' : 'Add Navigation'}</span>
          </button>
        )}
      </div>
      
      {/* ✅ Modern Navigation System 2025 */}
      {isNavigationEnabled && (
        <NewNavCreator
          navigationData={pageData.navigation || {}}
          onUpdate={handleNavigationUpdate}
          isEditMode={true}
          isMobileView={isMobileView}
          colors={colors}
          spaceFonts={spaceFonts}
          isWidgetEditCollapsed={isWidgetEditCollapsed}
          isAddWidgetsCollapsed={isAddWidgetsCollapsed}
        />
      )}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="widget-list" type="widget">
          {(provided) => (
            <div 
              {...provided.droppableProps} 
              ref={provided.innerRef} 
              className="outer-preview-div"
            >
              {pageData.widgets.length > 0 ? (
                pageData.widgets.map((widget, index) => (
                  <Draggable key={widget.id} draggableId={widget.id} index={index}>
                    {(provided) => (
                      <div
                        className='inner_preview_div'
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        data-widget-id={widget.id}
                        onClick={() => handleWidgetClick(widget.id)}>
                        {renderWidget(widget)}
                      </div>
                    )}
                  </Draggable>
                ))
              ) : (
                <div className="widget-placeholder">
                  <div className="widget-placeholder-top">
                    <img src="/img/down_2.svg" alt="" />
                    <h4>Add your first widget</h4>
                  </div>
                  <div className="widget-placeholder-bottom">
                    <h1>Your Page is empty.</h1>
                    {spaceId && (
                      <div className="ai-page-creator-cta">
                        <p>Let AI create your first page with professional content</p>
                        <button 
                          className="ai-page-creator-btn"
                          onClick={() => setShowAIPageCreator(true)}
                        >
                          <i className="fas fa-magic"></i>
                          <span className="ai-page-creator-btn-text">Create with AI</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      
      {/* AI Page Creator Modal */}
      {showAIPageCreator && spaceId && (
        <AIPageCreator
          onClose={() => setShowAIPageCreator(false)}
          spaceId={spaceId}
          spaceName={spaceName}
          username={spaceId} // Using spaceId as username for now
        />
      )}
    </div>
  );
}

export default PagePreview;
